import type { ReactElement, ReactNode } from 'react';
import { EyebrowLabel } from './eyebrow-label';

interface FormSectionProps {
  /** 1부터 — 제목 위에 두 자리 번호(01·02…)로 싣는다. */
  readonly order: number;
  readonly title: string;
  readonly children: ReactNode;
}

/**
 * 입력 화면(견적 요청·주문하기)의 번호 붙은 묶음 — 작은 번호 머리말, 굵은 제목(h2)과 그 아래 검은 선(상품 상세 섹션 제목과 같은 결).
 * 이름 붙은 영역(region)으로 두지 않는다 — 제목("수량·인쇄"·"배송지")이 안의 입력 라벨과 겹쳐 읽히지 않게, 구조는 제목 단계로만 준다.
 */
export const FormSection = ({ order, title, children }: FormSectionProps): ReactElement => (
  <section className="flex flex-col gap-6">
    <div className="flex flex-col gap-3 border-b border-foreground pb-4">
      <EyebrowLabel className="tabular-nums">{String(order).padStart(2, '0')}</EyebrowLabel>
      <h2 className="text-2xl leading-tight font-bold tracking-[-0.02em]">{title}</h2>
    </div>
    {children}
  </section>
);
